import { type ReactNode } from "react";
import { Link } from "react-router-dom";
import { XStack } from "tamagui";

import {
  AppCard,
  AppCardBody,
  AppContentContainer,
  AppShell,
  AppShellMain,
  AppText,
} from "../../ui-foundation";
import {
  KINDRED_PRIVACY_DATA_RIGHTS_LABEL,
  STEADY_HOUSE_COMPANY_NUMBER,
  STEADY_HOUSE_LEGAL_NAME,
} from "../../shared/support";

type PublicFooterLink = {
  href: string;
  label: string;
};

type PublicMarketingPageProps = {
  children: ReactNode;
};

type PublicMarketingFooterProps = {
  links?: PublicFooterLink[];
  note?: string;
};

const DEFAULT_FOOTER_LINKS: PublicFooterLink[] = [
  { href: "/about-kindred", label: "About Kindred" },
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/data-rights", label: KINDRED_PRIVACY_DATA_RIGHTS_LABEL },
  { href: "/terms", label: "Terms of Use" },
  { href: "/conduct", label: "Community Guidelines" },
  { href: "/child-safety", label: "Child Safety" },
  { href: "/editorial-policy", label: "Editorial Policy" },
  { href: "/contact-complaints", label: "Contact & complaints" },
];

export function PublicMarketingPage({ children }: PublicMarketingPageProps) {
  return (
    <AppShell minHeight="100vh">
      <AppShellMain>{children}</AppShellMain>
    </AppShell>
  );
}

export function PublicBrandCard() {
  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <AppCard backgroundColor="$cardBackground" borderRadius="$md">
        <AppCardBody alignItems="center" justifyContent="center" px="$lg" py="$md">
          <img
            src="/kindred-logo-full.png"
            alt="Kindred Community"
            style={{ display: "block", height: 48, width: "auto" }}
          />
        </AppCardBody>
      </AppCard>
    </Link>
  );
}

export function PublicMarketingFooter({
  links = DEFAULT_FOOTER_LINKS,
  note = `© 2026 Kindred Community. Operated by ${STEADY_HOUSE_LEGAL_NAME} (company ${STEADY_HOUSE_COMPANY_NUMBER}).`,
}: PublicMarketingFooterProps) {
  return (
    <footer className="kindred-brand-footer">
      <AppContentContainer py="$lg" alignItems="center" gap="$sm">
        <img src="/kindred-logo-full.png" alt="Kindred" style={{ display: "block", height: 24, opacity: 0.7 }} />
        <XStack flexWrap="wrap" justifyContent="center" gap="$sm">
          {links.map((link) =>
            link.href.startsWith("/") ? (
              <Link
                key={link.href}
                to={link.href}
                className="text-xs text-white/50 transition hover:text-white/75"
                style={{ textDecoration: "none" }}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                className="text-xs text-white/50 transition hover:text-white/75"
                style={{ textDecoration: "none" }}
              >
                {link.label}
              </a>
            ),
          )}
        </XStack>
        <AppText fontSize="$xs" lineHeight="$sm" textAlign="center" style={{ color: "rgba(255,255,255,0.35)" }}>
          {note}
        </AppText>
      </AppContentContainer>
    </footer>
  );
}
